import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { enpointCervinoWeb } from '../configuration/enpointsCervino';
import { LoadingService } from './../services/loading/loading.service';
import { ToastHandlerService } from '../services/toast/toast-handler.service';

// Header para que el interceptor NO muestre el spinner global.
const SKIP_LOADER_HEADER = 'X-Skip-Loader';

@Injectable()
export class GeneralInterceptor implements HttpInterceptor {
  constructor(
    private loadingService: LoadingService,
    private toastHandlerService: ToastHandlerService
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Si la request trae el header X-Skip-Loader, no mostramos el spinner global
    const skipLoader = req.headers.has(SKIP_LOADER_HEADER);

    if (skipLoader) {
      // Se elimina el header para que no llegue al backend
      req = req.clone({ headers: req.headers.delete(SKIP_LOADER_HEADER) });
    }

    // Solo se muestra si pasan 300 ms
    let showLoaderTimeout: any;
    if (!skipLoader) {
      showLoaderTimeout = setTimeout(() => {
        this.loadingService.show();
      }, 300);
    }

    let headers = {
      ClientNit: localStorage.getItem(AuthenticationContants.keyNitCLient)!,
      Authorization: '',
      Accept: 'application/json',
    };

    const token = localStorage.getItem(
      AuthenticationContants.keyTokenLocalStorage
    );

    if (!req.url.endsWith(enpointCervinoWeb.login.LoginUser)) {
      headers = {
        ...headers,
        Authorization: `Bearer ${token}`,
        Accept: 'text/html',
      };
    }

    if (req.url.includes('/assets/i18n/')) {
      clearTimeout(showLoaderTimeout);
      return next.handle(req);
    }

    req = req.clone({ setHeaders: headers });

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error.error instanceof Blob &&
          error.error.type === 'application/json'
        ) {
          return new Observable<never>((observer) => {
            const reader = new FileReader();
            reader.onload = (e: any) => {
              try {
                const jsonError = JSON.parse(e.target.result);
                this.toastHandlerService.interceptorErrorHandle(
                  jsonError,
                  error.status,
                  true
                );
                observer.error(
                  new HttpErrorResponse({
                    error: jsonError,
                    headers: error.headers,
                    status: error.status,
                    statusText: error.statusText,
                    url: error.url!,
                  })
                );
              } catch (parseError) {
                console.error('Error parsing JSON from Blob:', parseError);
                this.toastHandlerService.interceptorErrorHandle(
                  error.message,
                  error.status
                );
                observer.error(error);
              }
            };
            reader.onerror = () => {
              this.toastHandlerService.interceptorErrorHandle(
                error.message,
                error.status
              );
              observer.error(error);
            };
            reader.readAsText(error.error);
          });
        } else {
          this.toastHandlerService.interceptorErrorHandle(error, error.status);
          return throwError(() => error);
        }
      }),
      finalize(() => {
        // Cancela el timeout si la petición terminó antes de 300 ms
        clearTimeout(showLoaderTimeout);
        this.loadingService.hide();
      })
    );
  }
}
